import React, { useState } from 'react';
import { Modal } from 'antd';
import LabelledInput from 'components/LabelledInput';
import { t } from 'helpers/i18n';
import { useDispatch } from 'react-redux';
import { showError, showLoading, showSuccess } from 'store/popup/actions';
import { Result } from 'util/result';
import { BaseResponse } from 'data/terra/api/terra/base/BaseResponse';

export interface BaseAddEntityPopupProps<T> {
  popupTitle: string;
  handleCloseModal: () => void;
  onSaveEntity: (data: EntityDesc) => Promise<Result<BaseResponse<T, void>>>;
  onSaveEntityResult: (result: Result<BaseResponse<T, void>>) => void;
}

export interface EntityDesc {
  name: string;
  code: string;
}

function BaseAddEntityPopup<T>(props: BaseAddEntityPopupProps<T>) {
  const { handleCloseModal } = props;
  const dispatch = useDispatch();
  const [entityDesc, setEntityDesc] = useState<EntityDesc>({
    name: '',
    code: '',
  });

  const onSaveProduct = async () => {
    if (entityDesc.name && entityDesc.code) {
      dispatch(showLoading());
      const result = await props.onSaveEntity(entityDesc);
      props.onSaveEntityResult(result);
      if (result.isSuccess()) {
        dispatch(showSuccess());
        props.handleCloseModal();
      } else {
        dispatch(showError(result.exception().message));
      }
    }
  };

  return (
    <Modal
      visible={true}
      title={props.popupTitle}
      onCancel={handleCloseModal}
      onOk={onSaveProduct}
    >
      <LabelledInput
        label={t('Name')}
        helperText={t('Name')}
        value={entityDesc.name}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setEntityDesc({ ...entityDesc, name: event.target.value });
        }}
        marginBottom={true}
        mode="horizontal"
      />
      <LabelledInput
        label={t('Code')}
        helperText={t('Code')}
        value={entityDesc.code}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setEntityDesc({ ...entityDesc, code: event.target.value });
        }}
        marginBottom={true}
        mode="horizontal"
      />
    </Modal>
  );
}

export default BaseAddEntityPopup;
